var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericObservationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "generic-observation-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133 112.04"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".generic-observation-icon_svg__cls-1{fill:#17c2c9}.generic-observation-icon_svg__cls-2{fill:none;stroke:#344154;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "generic-observation-icon_svg__cls-1",
    d: "M79.57 67.62H69.15V57.2h-5.3v10.42H53.43v5.3h10.42v10.42h5.3V72.92h10.42v-5.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "generic-observation-icon_svg__cls-2",
    d: "M134.92 58.62v65.25a5.14 5.14 0 01-5.14 5.15H18.22a5.14 5.14 0 01-5.14-5.15V58.62",
    transform: "translate(-7.5 -18.48)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "generic-observation-icon_svg__cls-2",
    d: "M66.44 62.47c-18.58-.18-37.14-1.09-55.53-4.21A2.31 2.31 0 019 56V37.77a5.14 5.14 0 015.14-5.14h119.72a5.14 5.14 0 015.14 5.14V56a2.31 2.31 0 01-1.91 2.27c-18.39 3.12-36.95 4-55.53 4.21-3.78.04-11.34.03-15.12-.01zM102.33 32.63V26a6 6 0 00-6-6H51.68a6 6 0 00-6 6v6.62",
    transform: "translate(-7.5 -18.48)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "generic-observation-icon_svg__cls-1",
    d: "M18.32 110.49v13.29h111.36v-13.29a704.11 704.11 0 01-111.36 0z",
    transform: "translate(-7.5 -18.48)"
  })));
}
export default SvgGenericObservationIcon;